// extracted by mini-css-extract-plugin
export default {"input":"InputNumberStyles_input__+b8XF","labelInputMobilePhone":"InputNumberStyles_labelInputMobilePhone__nilGi","label":"InputNumberStyles_label__T1cB5"};